/** Gap between the stage rail and toolbar+results — Opportunities V2 `18px`. */
export const PERSONA_STAGE_RAIL_GAP_CLASS = "pt-[18px]";

/** Page shell that bulk overlays pin to (Persona Opportunities set detail). */
export const PERSONA_OPPORTUNITIES_LAYOUT_ID = "persona-opportunities-layout";

/** Toolbar sits on the results block: 1px border, radius top. */
export const PERSONA_STAGE_TOOLBAR_CLASS =
  "flex min-h-16 shrink-0 flex-col gap-3 rounded-t-md border border-border bg-card px-4 py-3 sm:flex-row sm:items-center sm:justify-between";

/** Results share the toolbar’s side borders; radius bottom only. Scrolls in place. */
export const PERSONA_STAGE_RESULTS_CLASS =
  "min-h-0 flex-1 overflow-y-auto rounded-b-md border border-t-0 border-border";

/**
 * Hub list is its own card below the detached toolbar (`gap-3` on the stack).
 * Hugs its rows and scrolls once it reaches the bottom of the stack.
 */
export const PERSONA_HUB_RESULTS_CLASS =
  "min-h-0 flex-initial overflow-y-auto rounded-md border border-border";
